import { STAGE } from 'src/constants';
import { Domain, EnvType, IAuth } from "./auth.types";

const AUTH_CONFIGS: Record<EnvType, IAuth> = {
    dev: {
        region: 'us-east-1',
        Cognito: {
            userPoolId: "us-east-1_IqpxjitTi",
            userPoolClientId: "50ld5949a2qijaon5565m4m415",
            identityPoolId: "us-east-1:3e609782-a218-4865-9110-9d272328fa28",
            loginWith: {
                oauth: {
                    domain: "bluey-alpha.auth.us-east-1.amazoncognito.com",
                    scopes: ["openid", "email", "aws.cognito.signin.user.admin", "profile"],
                    responseType: "code",
                    redirectSignIn: ["http://localhost:1114"],
                    redirectSignOut: ["http://localhost:1114"]
                },
            }
        }

    },
    // Alpha and Beta configurations would be similar but with different values
    alpha: {
        region: 'us-east-1',
        Cognito: {
            userPoolId: "us-east-1_IqpxjitTi",
            userPoolClientId: "50ld5949a2qijaon5565m4m415",
            identityPoolId: "us-east-1:3e609782-a218-4865-9110-9d272328fa28",
            loginWith: {
                oauth: {
                    domain: "bluey-alpha.auth.us-east-1.amazoncognito.com",
                    scopes: ["openid", "email", "aws.cognito.signin.user.admin", "profile"],
                    responseType: "code",
                    redirectSignIn: ["https://alpha.bluey.device.finance.amazon.dev"],
                    redirectSignOut: ["https://alpha.bluey.device.finance.amazon.dev"],
                },
            }
        }
    },
    // Prod configurations would be similar but with different values
    prod: {
        region: 'us-east-1',
        Cognito: {
            userPoolId: "us-east-1_3vnc8P8ir",
            userPoolClientId: "1ht16h6o1vkaj7ghuuo1fmmg3u",
            identityPoolId: "us-east-1:915bdb4e-f0ad-495d-9846-ae44c1716967",
            loginWith: {
                oauth: {
                    domain: "bluey-prod.auth.us-east-1.amazoncognito.com",
                    scopes: ["openid", "email", "aws.cognito.signin.user.admin", "profile"],
                    responseType: "code",
                    redirectSignIn: ["https://bluey.device.finance.amazon.dev"],
                    redirectSignOut: ["https://bluey.device.finance.amazon.dev"],
                },
            }
        }
    }
}
export const getAuthConfig = (): IAuth => {
    const stage = STAGE?.toLowerCase() ?? 'alpha';
    return AUTH_CONFIGS[stage as Domain];
};